export default "__VITE_ASSET__DhZFClLr__"